import { useFlags } from "flagsmith/react";
import { UseTagsProps, UseTagsReturnType } from "./types";
import { useTags as useTagsFS } from "./useTagsFS";
import { useTags as useTagsLegacy } from "./useTagsLegacy";

export function useTags(props: UseTagsProps): UseTagsReturnType {
  const flags = useFlags(["tags-form-service"]);
  const isFormServiceEnabled = flags["tags-form-service"].enabled;

  // TODO: remove legacy when the new formservice tags are widely used
  const legacy = useTagsLegacy(props, isFormServiceEnabled);

  // TODO: remove skip when the new formservice tags are widely used
  const fs = useTagsFS(props, !isFormServiceEnabled);

  return isFormServiceEnabled ? fs : legacy;
}
